import QuestionGeneratorHelper from '../core/question_generator_helper.js'
import highlightCode from './highlight_code.js'
import getUrlParams from 'toxilibs/url_params.js'


const jsToPython = {
    true:  'True',
    false: 'False'
}


QuestionGeneratorHelper.prototype.addPythonCode = function (source, answer) {
    // We keep this line for safety but answer should be defined before by function addCode of language_handler.js
    if (typeof this.answer === 'undefined' && answer) {
        this.answer = answer
    }
    this.container.append(highlightCode(source, 'python'))
}


//FIXME
const {theme} = getUrlParams()

if (theme === 'basic_python') {
    QuestionGeneratorHelper.prototype.translateChoice = function (choice) {
        return translate(choice)
    }
}



function translate (value) {
    for (let keyWord in jsToPython) {
        const replacement = jsToPython[keyWord]
        value = String(value).replace(new RegExp(keyWord, 'g'), replacement)
    }
    return value
}



